import React from "react";
import "./CyientGrid.css";

const data = [
  {
    title: "IT & Non-IT Jobs",
    description: "Opportunities across multiple industries tailored for freshers, professionals, and experts.",
    image: "https://images.unsplash.com/photo-1624377632657-3902bfd35958?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTU2fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
  },
  {
    title: "Career Guidance",
    description: "Personalized career counseling, resume building, and interview preparation.",
    image: "https://images.unsplash.com/photo-1630673429477-186308ef87d0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjI4fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
  },
  {
    title: "Freelance & Remote Work",
    description: "Flexible opportunities for freelancers and remote workers across industries.",
    image: "https://freelancinghacks.com/wp-content/uploads/2022/09/best-freelance-skills-to-learn.jpg"
  },
  {
    title: "Recruiter Support",
    description: "Connecting recruiters with skilled talent pools to simplify hiring.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  }
];

const CyientGrid = () => {
  return (
    <div className="cyient-container">
      <h2 className="cyient-heading"><span>WHAT WE </span> OFFER</h2>
      <p className="cyient-subheading">
        Comprehensive solutions for job seekers, students, freshers, freelancers, remote workers, and recruiters—helping you grow in every step of your career journey.
      </p>
      <div className="cyient-grid">
        {data.map((item, index) => (
          <div key={index} className="cyient-card">
            <img src={item.image} alt={item.title} />
            <div className="cyient-card-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CyientGrid;
